import { CreateQuoteInput } from '__generated__/GQL';
import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';

import { refetchGetClientStatusOverview } from '../../../../Clients/pages/List/components/ListItem/hooks/mutations/useClientStatusOverview';
import {
  CreateQuoteDocument,
  CreateQuoteMutation,
} from './graphql/createQuote.gql';

const useCreateQuote = () => {
  const [mutation, hook] =
    useErrorHandledMutation<CreateQuoteMutation>(CreateQuoteDocument);

  const createQuote = (input: CreateQuoteInput, clientId: string) =>
    mutation({
      awaitRefetchQueries: true,
      refetchQueries: [refetchGetClientStatusOverview(clientId)],
      variables: { input },
    });

  return [createQuote, hook] as const;
};

export default useCreateQuote;
